import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=2f60644d"
import script from "./FormCustomer.vue?vue&type=script&lang=js"
export * from "./FormCustomer.vue?vue&type=script&lang=js"
import style0 from "./FormCustomer.vue?vue&type=style&index=0&id=2f60644d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports